import axios from 'axios';

const getHomeDataApi = async (token, langIsoCode) => {
  try {
    const url = '/General/home';
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });

    return res;
  } catch (error) {
    throw error;
  }
};

export default getHomeDataApi;
